import { render } from "./MainCard.vue?vue&type=template&id=52a37fb6&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"

import "./MainCard.vue?vue&type=style&index=0&id=52a37fb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a37fb6"]])

export default __exports__